<app-page-content>
  <app-doenkids-menu-bar [showBackButton]="true" menuBar> </app-doenkids-menu-bar>
  <div class="content" content>
    @if (isLoading$ | async) {
      <div class="spinner">
        <mat-spinner></mat-spinner>
      </div>
    } @else {
      @if (newsItem$ | async; as item) {
        <app-newsfeed-item [message]="item"></app-newsfeed-item>
      }
    }
    <ng-template #content>
      @if (newsItem$ | async; as item) {
        <app-newsfeed-item [message]="item"></app-newsfeed-item>
      }
    </ng-template>
  </div>

</app-page-content>
